import React, { useState } from 'react';
import { SkillCategoriesWizard } from './skill-categories-wizard';
import { PagePath } from '../../../navigation/navigation.enums';
import { PageLoaderLayer } from '../../../components/general/loading-state/loader-layers/page-loader-layer/page-loader-layer';
import { PageHeader } from '@keplerco/core';
import { useAppState } from '../../../overmind';
import { GetSkillCategoryResponse } from '../../../overmind/actions';

export function SkillCategoriesCreatePage(): React.ReactElement {
  const { companyVariables } = useAppState();

  const [skillCategory, setSkillCategory] = useState<GetSkillCategoryResponse>();

  return (
    <PageLoaderLayer path={PagePath.roleSkillManagementSkillCategoriesCreate}>
      <div className="wrapper stack" style={{ paddingBottom: 24, gap: 24 }}>
        <PageHeader
          breadcrumbs={[
            { name: 'Roles & skills', url: `${PagePath.roleSkillManagementBase}` },
            { name: 'Manage skill categories', url: `${PagePath.roleSkillManagementBase}${PagePath.roleSkillManagementSkillCategories.replace(':companySlug', companyVariables.slug!)}` },
            { name: 'Create skill category', url: location.href },
          ]}
          title="Create skill category"
          subtitle="Create a grouping of skills to streamline role management, assessment management and analytics"
        />

        <SkillCategoriesWizard skillCategory={skillCategory} setSkillCategory={setSkillCategory} />
      </div>
    </PageLoaderLayer>
  );
}
